<template>
  <el-table
    :data="invoices"
    stripe
  >
    <el-table-column
      label="Invoice #"
      :formatter="row => row.invoice_account_counter || '-'"
      width="130px"
    />

    <el-table-column
      label="Parent Invoice #"
      :formatter="row => $_.get(row, 'parent.invoice_account_counter') || '-'"
      width="130px"
    />

    <el-table-column
      label="Invoiced At"
      :formatter="row => row.invoice_date ? $moment(row.invoice_date).format('DD/MM/YYYY') : '-'"
      width="180px"
    />

    <el-table-column
      label="Amount (ex. GST)"
      :formatter="row => calculateTotalExGST(row) || '-'"
      width="160px"
    />

    <el-table-column
      label="Amount (inc. GST)"
      :formatter="row => calculateTotalSell(row) || '-'"
      width="160px"
    />

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="right"
      width="160px"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :invoice="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    invoices: {
      type: Array,
      required: true
    }
  },
  methods: {
    calculateTotalSell (invoice) {
      let sum = 0

      try {
        sum = invoice.sell_rate + invoice.sell_fuel + invoice.sell_fees + invoice.sell_tax
      } catch {}

      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(sum)
    },
    calculateTotalExGST (invoice) {
      let sum = 0

      try {
        sum = invoice.sell_rate + invoice.sell_fuel + invoice.sell_fees
      } catch {}

      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(sum)
    }
  }
}
</script>
